import { apiRequest } from './apiWrapper'
import { API_METHOD, API_END_POINT } from '../utils/constants'
const accessToken = localStorage.getItem('access')

export const fetchCoinTransaction = async ({ fromDate, toDate,items,page }) => {
  const accessToken = localStorage.getItem('access')

  const response = await apiRequest({
    method: API_METHOD.Get,
    url: API_END_POINT.getRewardsTransactions,
    params: { fromDate, toDate,items,page },
    headers: {
      'x-api-token': accessToken
    },
    skipCache:true
  })
  return response
}

export const fetchCreditBalance = async () => {
  const accessToken = localStorage.getItem('access')

  const response = await apiRequest({
    method: API_METHOD.Get,
    url: API_END_POINT.creditBalance,
    headers: {
      'x-api-token': accessToken
    },
    skipCache:true
  })
  return response
}
export const fetchCoinBalance = async () => {
  const accessToken = localStorage.getItem('access')

  const response = await apiRequest({
    method: API_METHOD.Get,
    url: API_END_POINT.coinBalance,
    headers: {
      'x-api-token': accessToken
    },
    skipCache:true
  })
  return response
}
export const coinToCredit = async (coins) => {
  const accessToken = localStorage.getItem('access')

  const response = await apiRequest({
    method: API_METHOD.Post,
    url: API_END_POINT.coinConvert,
    data: { coins: coins },
    headers: {
      'x-api-token': accessToken
    }
  })
  return response
}

export const fetchEarnCoins = async (coins) => {
  const response = await apiRequest({
    method: API_METHOD.Get,
    url: API_END_POINT.earnMoreCoin
  })
  return response
}

export const fetchCreditTransaction = async ({ fromDate, toDate }) => {
  const accessToken = localStorage.getItem('access')

  const response = await apiRequest({
    method: API_METHOD.Get,
    url: API_END_POINT.creditTransaction,
    params: { fromDate, toDate },
    headers: {
      'x-api-token': accessToken
    },
    skipCache:true

  })
  return response
}
